import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { JobWithQuotesResult } from '../models/job-with-quotes-result.model';

@Injectable({
  providedIn: 'root',
})
export class JobQuotesListByJobKeyGQL extends Query<JobWithQuotesResult, { jobKey: string }> {
  override document = gql`
    query ($jobKey: UUID!) {
      job(jobKey: $jobKey) {
        name
        key
        accountNumber
        countryCode
        jobQuotes
        isActive
        jobType
        salesRep {
          email
        }
        secondarySalesRep {
          email
        }
        pickupAddressDetails {
          storeNumber: sapId
          name
          phoneNumber
          address1
          address2
          city
          countryCode
          state
          postcode
          latitude
          longitude
          key
        }
      }
    }
  `;
}
